import React from "react";
import MerchantSettleListPanel from "../../components/merchantSettle/MerchantSettleListPanel";

const MerchantIncome = () => (
  <MerchantSettleListPanel
    mode="merchant"
    tableScrollY="calc(100vh - 48vh)"
    defaultPageSize={10}
  />
);

export default MerchantIncome;
